import { render, staticRenderFns } from "./dengLu.vue?vue&type=template&id=4bc14bac&scoped=true"
import script from "./dengLu.vue?vue&type=script&lang=js"
export * from "./dengLu.vue?vue&type=script&lang=js"
import style0 from "./dengLu.vue?vue&type=style&index=0&id=4bc14bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc14bac",
  null
  
)

export default component.exports